module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-wrapper span-full bgblack",
    staticStyle: {
      "background-image": "url('/static/images/footer-bg.jpg')"
    },
    attrs: {
      "id": "contact",
      "data-type": "layout"
    }
  }, [_c('div', {
    staticClass: "table-wrap"
  }, [_c('div', {
    staticClass: "table-cell"
  }, [_c('div', {
    staticClass: "content-750"
  }, [_c('h3', [_vm._v(_vm._s(_vm.page.title))]), _vm._v(" "), _c('div', {
    staticClass: "entry-content pt3",
    domProps: {
      "innerHTML": _vm._s(_vm.page.content)
    }
  }), _vm._v(" "), _c('contact')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "footer-credits pb2"
  }, [_c('div', {
    staticClass: "span-3"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('p', [_vm._v("Natura — All Rights Reserved " + _vm._s(_vm.year))]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.footer.email
    }
  }, [_vm._v(_vm._s(_vm.footer.email))])])]), _vm._v(" "), _c('div', {
    staticClass: "item text-right"
  }, [_c('a', {
    attrs: {
      "href": _vm.footer.instagram,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "instagram"
    }
  })], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.footer.facebook,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "facebook"
    }
  })], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.footer.twitter,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "twitter"
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item text-left"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "//www.naturaselection.com/"
    }
  }, [_c('img', {
    staticClass: "pr1",
    attrs: {
      "src": "/static/images/footer-credits-naturaplastickill-1.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "//www.plasticpollutioncoalition.org/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/footer-credits-naturaplastickill-2.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Designed by "), _c('a', {
    attrs: {
      "href": "http://septimo.co/",
      "target": "_blank"
    }
  }, [_vm._v("Séptimo Studio")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2255ae78!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 158
// module chunks = 1